import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpShortWide } from "@fortawesome/free-solid-svg-icons";
import {  } from "./FilterArrowUp.styles";

const DownArrow = () => {
    return (
        <FontAwesomeIcon icon={faArrowUpShortWide} />
    )
}

export default DownArrow;